export const WEBPERFORMANCE_CORE_SCENE = 'webPerformanceCoreScene'
export const WEBPERFORMANCE_INDICATOR = 'webPerformanceIndicator'
export const WEBPERFORMANCE_ALPHA = 'webPerformanceAlpha'

const perfix = 'npds'
export const WEB_PERFORMANCE_CORE_SCENE_MAP = {
  workbench: `${perfix}_workbench`
}
